/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/customer';
import '../../../../connect/v2/resources/error';
import '../../models/feature_flags';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveCustomerRequest": {
                    "fields": {
                      "fieldsToInclude": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "RetrieveCustomerResponse": {
                    "fields": {
                      "customer": {
                        "type": ".squareup.sfs.external.models.Customer",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "featureFlags": {
                        "type": ".squareup.sfs.external.models.FeatureFlags",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveCustomerRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveCustomerResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Response will be based on the currently authorized Multipass person.
 * --
 *
 * SOURCE RetrieveCustomerRequest @ squareup/sfs/external/services/customer/retrieve_customer.proto at 12:1
 */
export const RetrieveCustomerRequest = $root.lookupType('squareup.sfs.external.service.RetrieveCustomerRequest');
fixType(RetrieveCustomerRequest);
Builder.createAndAttachToType(RetrieveCustomerRequest);
/**
 * SOURCE RetrieveCustomerResponse @ squareup/sfs/external/services/customer/retrieve_customer.proto at 21:1
 */
export const RetrieveCustomerResponse = $root.lookupType('squareup.sfs.external.service.RetrieveCustomerResponse');
fixType(RetrieveCustomerResponse);
Builder.createAndAttachToType(RetrieveCustomerResponse);